<template>
  <div class="EFM100-view" v-if="showRealDataDom">
    <el-row type="flex" class="overall-status" justify="end">
      <el-col tag="span" :span="5">
        {{ $t('检测结果') }}：
        <span :class="testState | alarmClass">{{ testRes }}</span>
      </el-col>
    </el-row>
    <div class="chart-area">
      <v-chart class="chart" :options="chartData" :autoresize="true" />
    </div>
  </div>

  <el-empty v-else :image-size="200" description="暂无数据"></el-empty>
</template>

<script>
import { tools } from '../CT1226/utils';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';

import singleDeviceMixin from '@/mixins/singleDeviceMixin';

export default {
  name: 'EFM100',
  filters: tools,
  mixins: [singleDeviceMixin],
  data() {
    return {
      showRealDataDom: false,
      testState: 0,
      testRes: '-',
      chartData: lineAreaStyle({
        color: ['#833BBB', '#3368F2', '#33BBF2'],
        legend: {
          top: 'auto',
          right: '5%',
          icon: 'circle',
          orient: 'vertical',
          textStyle: {
            color: '#fff'
          }
        },
        // title: { text: 'β', left: 'center' },
        yAxis: { type: 'value' },
        xAxis: {
          type: 'category',
          data: []
        },
        series: [
          {
            name: '荧光管1',
            type: 'line',
            symbol: 'emptyCircle',
            smooth: true,
            data: []
          },
          {
            name: '荧光管2',
            type: 'line',
            symbol: 'emptyCircle',
            smooth: true,
            data: []
          },
          {
            name: '荧光管3',
            type: 'line',
            symbol: 'emptyCircle',
            smooth: true,
            data: []
          }
        ]
      })
    };
  },
  methods: {
    updateData(res) {
      //   console.log('res: ', res);
      this.setData(res);
    },

    setData(res) {
      this.showRealDataDom = true;
      const {
        mods: { detectionMod }
      } = res;
      this.testRes = detectionMod.testResult;
      this.testState = detectionMod.state;

      const {
        data: { rawXYDatas }
      } = detectionMod;
      this.chartData.xAxis.data = rawXYDatas[0]?.xAxis || [];

      for (let i = 0; i < rawXYDatas.length; i++) {
        // this.chartData.series[i].name = rawXYDatas[i]?.name || '';
        this.chartData.series[i].data = rawXYDatas[i]?.yAxis || [];
      }
    }
  },
  created() {}
};
</script>

<style scoped lang="scss">
.EFM100-view {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  .overall-status {
    font-weight: bold;
    font-size: 20px;
    span {
      @include state-textstyle;
    }
  }

  .chart-area {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: calc(100% - 100px);
    .chart {
      border: 1px solid rgb(96, 118, 173) !important;
    }
  }
}
</style>
